module.exports = __webpack_public_path__ + "img/oneAndon.75e94032.png";